import { connect } from "react-redux"
import { requestInvitationStatus, loadedPendingInvitation } from "../../api"
import InvitationLoaderView from "../components/InvitationLoaderView.react"

export default connect(() => ({}), {
  loadInvitation: requestInvitationStatus,
  handleInvitationLoaded: loadedPendingInvitation,
})(InvitationLoaderView)
